import cx from 'classnames';
import React from 'react';
export const ButtonGroup = ({ children, className, layout, ...rest }) => (React.createElement("div", { className: cx('tds-btn_group', {
        [`tds-btn_group--${layout}`]: layout,
    }, className), ...rest }, children));
